import * as React from 'react';

const EyeCrossed24 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "m20.496 3-3.6 3.584A12.016 12.016 0 0 0 12 5.547c-4.82 0-8.99 2.846-11 6.967a12.5 12.5 0 0 0 4.713 5.199l-3.248 3.231L3.525 22 21.558 4.056 20.497 3ZM12 7.04c1.308 0 2.573.237 3.75.683L13.523 9.94A2.997 2.997 0 0 0 12 9.528c-1.657 0-3 1.337-3 2.986 0 .553.151 1.07.414 1.515l-2.611 2.599a10.92 10.92 0 0 1-4.113-4.114C4.63 9.12 8.13 7.04 12 7.04Zm6.418 2.163 1.064-1.059A12.545 12.545 0 0 1 23 12.514c-2.01 4.13-6.18 6.966-11 6.966-1.185 0-2.33-.172-3.415-.492l1.233-1.226a10.64 10.64 0 0 0 2.182.225c3.87 0 7.37-2.08 9.31-5.473a11.017 11.017 0 0 0-2.892-3.311Z"
  }
));
EyeCrossed24.Size = 24;
EyeCrossed24.Title = "EyeCrossed";

export { EyeCrossed24 as default };
